import type { Pinia } from 'pinia';
import { storeAutoResetPlugin } from '~/utils/storeAutoReset';

/**
 * 註冊「自動 reset」的 pinia plugin。
 *
 * 必須早於任何 store 被建立，否則先建立的 store 拿不到補上的 reset()，
 * 所以檔名用 01. 排在其他 plugin 之前（00. 是 cookie 遷移，要更早）。
 */
export default defineNuxtPlugin({
  name: 'pinia-auto-reset',
  dependsOn: ['pinia'],
  setup(nuxtApp) {
    (nuxtApp.$pinia as Pinia).use(storeAutoResetPlugin);
  },
});
